import { BidFormSchema } from "./schemas";
import { z } from "zod";

export type BidFormValues = z.infer<typeof BidFormSchema>;

export enum FirmnessLevelEnum {
  FIRM = "FIRM",
  SOFT = "SOFT",
  LOOSYGOOSY = "LOOSYGOOSY",
}
